import { Avatar, AVATAR_HEIGHT_24 } from '../../Avatar'

function TagAvatar({ size = AVATAR_HEIGHT_24, ...restProps }) {
  return <Avatar {...restProps} size={size} />
}

export default TagAvatar
